/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 查询公司
 */
import styles from './company.scss';
import React from 'react';
import cns from 'classnames';
import { Tabs } from 'antd';
import cancel from '../../../utils/cancel';
import GroupBox from '../../common/groupBox/GroupBox';
import TableSearch from '../../common/tableSearch/TableSearch';
import CompanySearchForm from './company/CompanySearchForm';
import FilterSearchForm from './company/FilterSearchForm';
import OverviewModal from './company/OverviewModal';
import CompanyTable from './common/CompanyTable';

const TabPane = Tabs.TabPane;

@cancel
export default class Company extends TableSearch {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: {},
            initialized: false,
            visible: false,
            modalKey: +new Date(),
            activeItem: {}
        };
    }

    onSearch = (searchParams) => {
        this.setState({
            searchParams,
            initialized: true
        });
    };

    getHandleColumn = () => {
        return {
            title: '分析概览',
            dataIndex: 'overview',
            width: 80,
            className: 'operation',
            render: (v, d) => <a href="javascript:void(0)" onClick={() => this.showModal(d)}>查看</a>
        };
    };

    render() {
        const { options } = this.props;
        const { searchParams, visible, modalKey, activeItem, initialized } = this.state;
        return (
            <div className="base-panel">
                <GroupBox title="查询公司">

                    <Tabs defaultActiveKey="company" animated={false} className="line-tabs margin">
                        <TabPane tab="公司搜索" key="company">
                            <CompanySearchForm onSearch={this.onSearch}/>
                        </TabPane>
                        <TabPane tab="公司筛选" key="filter">
                            <FilterSearchForm options={options} onSearch={this.onSearch}/>
                        </TabPane>
                    </Tabs>

                    <CompanyTable
                        className={cns(styles.companyTable, { 'hidden': !initialized })}
                        searchParams={searchParams}
                        handleColumn={this.getHandleColumn()}
                    />

                </GroupBox>

                <OverviewModal
                    key={modalKey}
                    visible={visible}
                    item={activeItem}
                    options={options}
                    onCancel={this.hideModal}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/Company.jsx